import { render, staticRenderFns } from "./questionTypeNumber.vue?vue&type=template&id=55f10844&scoped=true&"
import script from "./questionTypeNumber.vue?vue&type=script&lang=js&"
export * from "./questionTypeNumber.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeNumber.vue?vue&type=style&index=0&id=55f10844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f10844",
  null
  
)

export default component.exports